import type { FaireProductEntity } from "../../entity_types/product";

export const p_apcuwrc6nm: FaireProductEntity = {
  token: "p_apcuwrc6nm",
  type: "product",
  name: "Bridget Sweater - Drift",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/b2658b4164366cda70294cd0dc8e3aa92ced99c8f2e14b6b811beffe2a70011e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0bb130ce54c860a5bfe1fcabf895bcd1d824773f600473b83036f18eb08459b6.jpeg",
    "https://cdn.faire.com/fastly/d46010522058861d258e5613ab5e2065dc5d267e8205cf8dbb1eecb2fc6e8548.jpeg",
    "https://cdn.faire.com/fastly/57aec91d00d49baa2542b3c8decf3fecd3c1c72ad3a74bd5349aa62f025fda49.jpeg",
    "https://cdn.faire.com/fastly/ea7c182ae8c8dc8d066f912427557a6e31791f9391433d08170caf76e4b5474a.jpeg"
  ],
  priceDollars: 111.6,
  description: "A grid that shifts as you look at it, borrowed from the op art of Bridget Riley. Double knit means two faces worked as one — that is where the warmth comes from, without the stiffness.\n\n * 100% Merino Wool \n * Artisan made in Peru with Fair Trade practices to maintain ethical and responsible integrity \n * Relaxed and straight through the body, in a v-neck ",
  tags: [],
  msrpDollars: 248,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:31.417Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
